let CryptLib = require("cryptlib");
const webEncrypt  = require('./webchatEncryptDecrypt.js');


module.exports = {

  checklogin: function (username, password) {

    if (username != "" && password != "") {
      let loginUserInfo = [];
      let info = [username, password];
      let key = CryptLib.getHashSha256(username, 32);
      let cypherText = CryptLib.encrypt(JSON.stringify(info), key, username);
      sessionStorage.Info = cypherText;
      loginUserInfo[0] = [];
      loginUserInfo[0].push(username);
      let checkRemember = localStorage.getItem("remember-me");
      if (checkRemember == "true") {
        let UserInfo = {};
        UserInfo[0] = [];
        UserInfo[0].push(cypherText);
        webEncrypt.encryptAndStoreInLocalStorage('UserInfo', UserInfo);
        webEncrypt.encryptAndStoreInLocalStorage('loginUserInfo', loginUserInfo);
      } else {
        let currentItem = localStorage.getItem("localization");
        let ChatWebId = webEncrypt.getFromLocalStorageAndDecrypt('ChatWebId')

        if (currentItem != null) {
          localStorage.setItem("localization", currentItem);
        }
        webEncrypt.encryptAndStoreInLocalStorage('loginUserInfo', loginUserInfo);
        webEncrypt.encryptAndStoreInLocalStorage('ChatWebId', ChatWebId);
        webEncrypt.deleteItemFromLocalStorage('UserInfo');
      }
      $("#login").trigger("click");

    }
  },
  getChecked: function () {
    localStorage.setItem("rememberme", "false");
    return localStorage.getItem("rememberme");
  }
};
